module.exports = __webpack_public_path__ + "img/success.6106929b.png";